import React, { useEffect, useState } from 'react';
import { Upload, Button, Image, message, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api from '@/services/api';

const LogoTab = () => {
    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const response = await api()({
                url: '/webshop/management/settings/multiple',
                method: 'GET',
                params: { query: 'favicon' }
            });

            const logoUrl = response.data.data.find(item => item.Keyword === 'favicon')?.Value;
            if (logoUrl) setImageUrl(logoUrl);

        } catch (error) {
            console.error('Error fetching logo:', error);
            message.error('Failed to load logo');
        } finally {
            setLoading(false);
        }
    };

    const handleUpload = async ({ file }) => {
        const formData = new FormData();
        formData.append('file', file);

        try {
            setLoading(true);

            // ⬆️ 1. Upload image to server
            const uploadRes = await api()({
                url: '/webshop/management/upload',
                method: 'POST',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            const uploadedUrl = uploadRes.data?.url;
            if (!uploadedUrl) throw new Error('No URL returned from upload');

            // ✅ 2. Save image URL as setting
            await api()({
                url: '/webshop/management/settings',
                method: 'POST',
                data: {
                    data: {
                        'favicon': uploadedUrl
                    }
                }
            });

            setImageUrl(uploadedUrl);
            message.success('Logo uploaded successfully');
        } catch (error) {
            console.error('Upload error:', error);
            message.error('Upload failed');
        } finally {
            setLoading(false);
        }
    };

    const handleRemove = () => {
        setImageUrl(null);
        // (Opsiyonel) Backend'den de silmek istersen, burada ekleyebilirim
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    return (
        <Spin spinning={loading}>
            <Upload
                showUploadList={false}
                customRequest={handleUpload}
                accept="image/*"
            >
                <Button icon={<UploadOutlined />}>Upload Logo</Button>
            </Upload>

            {imageUrl && (
                <div style={{ marginTop: 16 }}>
                    <Image width={100} src={imageUrl} alt="Logo" />
                   
                </div>
            )}
        </Spin>
    );
};

export default LogoTab;
